import { Capacitor } from '@capacitor/core';

export const isNative = Capacitor.isNativePlatform();
export const isIOS = Capacitor.getPlatform() === 'ios';
export const isAndroid = Capacitor.getPlatform() === 'android';
export const platform = Capacitor.getPlatform();

/** Path inside the app (works with HashRouter on native). */
export function getAppPathname() {
  if (isNative && window.location.hash.startsWith('#')) {
    const hashPath = window.location.hash.slice(1);
    return hashPath.split('?')[0] || '/';
  }
  return window.location.pathname || '/';
}

/** Search string inside the app (?foo=bar). */
export function getAppSearch() {
  if (isNative && window.location.hash.includes('?')) {
    return `?${window.location.hash.split('?').slice(1).join('?')}`;
  }
  return window.location.search || '';
}

export function navigateTo(path) {
  if (isNative) {
    window.location.hash = path.startsWith('/') ? path : `/${path}`;
    return;
  }
  window.location.assign(path);
}
